//CATEGORY
// ADD CATEGORY
export const ADMIN_ADD_CATEGORY_SET_CATEGORY = "ADMIN_ADD_CATEGORY_SET_CATEGORY"
export const ADMIN_ADD_CATEGORY_SET_SUCCESS_MESSAGE = "ADMIN_ADD_CATEGORY_SET_SUCCESS_MESSAGE"
export const ADMIN_ADD_CATEGORY_SET_ERROR_MESSAGE = "ADMIN_ADD_CATEGORY_SET_ERROR_MESSAGE"
export const ADMIN_ADD_CATEGORY_START_LOADING = "ADMIN_ADD_CATEGORY_START_LOADING"
export const ADMIN_ADD_CATEGORY_STOP_LOADING = "ADMIN_ADD_CATEGORY_STOP_LOADING"
export const ADMIN_ADD_CATEGORY_RESET_FORM = "ADMIN_ADD_CATEGORY_RESET_FORM"
// SHOW CATEGORY
export const ADMIN_SHOW_SET_CATEGORIES = "ADMIN_SHOW_SET_CATEGORIES"
export const ADMIN_SHOW_CATEGORY_SET_ERROR_MESSAGE = "ADMIN_SHOW_CATEGORY_SET_ERROR_MESSAGE"
export const ADMIN_SHOW_CATEGORY_START_LOADING = "ADMIN_SHOW_CATEGORY_START_LOADING"
export const ADMIN_SHOW_CATEGORY_STOP_LOADING = "ADMIN_SHOW_CATEGORY_STOP_LOADING"
// UPDATE CATEGORY
export const ADMIN_UPDATE_CATEGORY_SET_ID_CATEGORY = "ADMIN_UPDATE_CATEGORY_SET_ID_CATEGORY"
export const ADMIN_UPDATE_CATEGORY_SET_CATEGORY = "ADMIN_UPDATE_CATEGORY_SET_CATEGORY"
export const ADMIN_UPDATE_CATEGORY_SET_SUCCESS_MESSAGE = "ADMIN_UPDATE_CATEGORY_SET_SUCCESS_MESSAGE"
export const ADMIN_UPDATE_CATEGORY_SET_ERROR_MESSAGE = "ADMIN_UPDATE_CATEGORY_SET_ERROR_MESSAGE"
export const ADMIN_UPDATE_CATEGORY_START_LOADING = "ADMIN_UPDATE_CATEGORY_START_LOADING"
export const ADMIN_UPDATE_CATEGORY_STOP_LOADING = "ADMIN_UPDATE_CATEGORY_STOP_LOADING"
// DELETE CATEGORY
export const ADMIN_DELETE_CATEGORY_SET_ID_CATEGORY = "ADMIN_DELETE_CATEGORY_SET_ID_CATEGORY"

//PRODUCT
// ADD PRODUCT
export const ADMIN_ADD_PRODUCT_SET_PRODUCT_NAME = "ADMIN_ADD_PRODUCT_SET_PRODUCT_NAME"
export const ADMIN_ADD_PRODUCT_SET_PRODUCT_DESCRIPTION = "ADMIN_ADD_PRODUCT_SET_PRODUCT_DESCRIPTION"
export const ADMIN_ADD_PRODUCT_SET_PRODUCT_PRICE = "ADMIN_ADD_PRODUCT_SET_PRODUCT_PRICE"
export const ADMIN_ADD_PRODUCT_SET_PRODUCT_PROMO = "ADMIN_ADD_PRODUCT_SET_PRODUCT_PROMO"
export const ADMIN_ADD_PRODUCT_SET_PRODUCT_STOCK = "ADMIN_ADD_PRODUCT_SET_PRODUCT_STOCK"
export const ADMIN_ADD_PRODUCT_SET_PRODUCT_MEASURE = "ADMIN_ADD_PRODUCT_SET_PRODUCT_MEASURE"
export const ADMIN_ADD_PRODUCT_SET_PRODUCT_IMAGE = "ADMIN_ADD_PRODUCT_SET_PRODUCT_IMAGE"
export const ADMIN_ADD_PRODUCT_SET_PRODUCT_CATEGORY_ID = "ADMIN_ADD_PRODUCT_SET_PRODUCT_CATEGORY_ID"
export const ADMIN_ADD_PRODUCT_SET_SUCCESS_MESSAGE = "ADMIN_ADD_PRODUCT_SET_SUCCESS_MESSAGE"
export const ADMIN_ADD_PRODUCT_SET_ERROR_MESSAGE = "ADMIN_ADD_PRODUCT_SET_ERROR_MESSAGE"
export const ADMIN_ADD_PRODUCT_START_LOADING = "ADMIN_ADD_PRODUCT_START_LOADING"
export const ADMIN_ADD_PRODUCT_STOP_LOADING = "ADMIN_ADD_PRODUCT_STOP_LOADING"
export const ADMIN_ADD_PRODUCT_RESET_FORM = "ADMIN_ADD_PRODUCT_RESET_FORM"
// SHOW PRODUCT
export const ADMIN_SHOW_SET_PRODUCTS = "ADMIN_SHOW_SET_PRODUCTS"
export const ADMIN_SHOW_PRODUCT_SET_ERROR_MESSAGE = "ADMIN_SHOW_PRODUCT_SET_ERROR_MESSAGE"
export const ADMIN_SHOW_PRODUCT_START_LOADING = "ADMIN_SHOW_PRODUCT_START_LOADING"
export const ADMIN_SHOW_PRODUCT_STOP_LOADING = "ADMIN_SHOW_PRODUCT_STOP_LOADING"
// UPDATE PRODUCT
export const ADMIN_UPDATE_PRODUCT_SET_ID_PRODUCT = "ADMIN_UPDATE_PRODUCT_SET_ID_PRODUCT"
export const ADMIN_UPDATE_PRODUCT_SET_PRODUCT_NAME = "ADMIN_UPDATE_PRODUCT_SET_PRODUCT_NAME"
export const ADMIN_UPDATE_PRODUCT_SET_PRODUCT_DESCRIPTION = "ADMIN_UPDATE_PRODUCT_SET_PRODUCT_DESCRIPTION"
export const ADMIN_UPDATE_PRODUCT_SET_PRODUCT_PRICE = "ADMIN_UPDATE_PRODUCT_SET_PRODUCT_PRICE"
export const ADMIN_UPDATE_PRODUCT_SET_PRODUCT_PROMO = "ADMIN_UPDATE_PRODUCT_SET_PRODUCT_PROMO"
export const ADMIN_UPDATE_PRODUCT_SET_PRODUCT_STOCK = "ADMIN_UPDATE_PRODUCT_SET_PRODUCT_STOCK"
export const ADMIN_UPDATE_PRODUCT_SET_PRODUCT_MEASURE = "ADMIN_UPDATE_PRODUCT_SET_PRODUCT_MEASURE"
export const ADMIN_UPDATE_PRODUCT_SET_PRODUCT_IMAGE = "ADMIN_UPDATE_PRODUCT_SET_PRODUCT_IMAGE"
export const ADMIN_UPDATE_PRODUCT_SET_PRODUCT_CATEGORY_ID = "ADMIN_UPDATE_PRODUCT_SET_PRODUCT_CATEGORY_ID"
export const ADMIN_UPDATE_PRODUCT_SET_SUCCESS_MESSAGE = "ADMIN_UPDATE_PRODUCT_SET_SUCCESS_MESSAGE"
export const ADMIN_UPDATE_PRODUCT_SET_ERROR_MESSAGE = "ADMIN_UPDATE_PRODUCT_SET_ERROR_MESSAGE"
export const ADMIN_UPDATE_PRODUCT_START_LOADING = "ADMIN_UPDATE_PRODUCT_START_LOADING"
export const ADMIN_UPDATE_PRODUCT_STOP_LOADING = "ADMIN_UPDATE_PRODUCT_STOP_LOADING"
// DELETE PRODUCT
export const ADMIN_DELETE_PRODUCT_SET_ID_PRODUCT = "ADMIN_DELETE_PRODUCT_SET_ID_PRODUCT"
export const ADMIN_DELETE_PRODUCT_SET_SUCCESS_MESSAGE = "ADMIN_DELETE_PRODUCT_SET_SUCCESS_MESSAGE"
export const ADMIN_DELETE_PRODUCT_SET_ERROR_MESSAGE = "ADMIN_DELETE_PRODUCT_SET_ERROR_MESSAGE"
export const ADMIN_DELETE_PRODUCT_START_LOADING = "ADMIN_DELETE_PRODUCT_START_LOADING"
export const ADMIN_DELETE_PRODUCT_STOP_LOADING = "ADMIN_DELETE_PRODUCT_STOP_LOADING"
//login
export const ADMIN_LOGIN_RESET_FORM = "ADMIN_LOGIN_RESET_FORM"
export const ADMIN_LOGIN_SET_EMAIL = "ADMIN_LOGIN_SET_EMAIL"
export const ADMIN_LOGIN_SET_PASSWORD = "ADMIN_LOGIN_SET_PASSWORD"
export const ADMIN_LOGIN_SET_ERROR_MESSAGE = "ADMIN_LOGIN_SET_ERROR_MESSAGE"
export const ADMIN_LOGIN_START_LOADING = "ADMIN_LOGIN_START_LOADING"
export const ADMIN_LOGIN_STOP_LOADING = "ADMIN_LOGIN_STOP_LOADING"
export const ADMIN_LOGIN_SET_ACCESS_TOKEN = "ADMIN_LOGIN_SET_ACCESS_TOKEN"
export const ADMIN_LOGIN_SET_LOGIN = "ADMIN_LOGIN_SET_LOGIN"
export const ADMIN_LOGIN_SET_LOGOUT = "ADMIN_LOGIN_SET_LOGOUT"